
/* eslint-disable max-classes-per-file */
/* eslint-disable no-bitwise */
import { flatMap, maxBy, minBy } from "lodash";
import { ArbetsorderHandelssortimentDTO } from "~app/common/models/planera/v2/ArbetsorderHandelssortimentDTO";
import { DestineringsalternativDTO } from "~app/common/models/planera/v2/DestineringsalternativDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";

export class ArbetsorderHandelssortimentViewModel {
    id: number;
    handelssortimentId: number;
    handelssortimentNamn: string;
    handelssortimentGuid: string;

    transportdatumBeraknatFrom: Date;
    transportdatumBeraknatTom: Date;

    beraknaNarmasteIndustri: boolean;
    avstandNarmasteIndustri: number;
    avstandNarmasteIndustriJusterat: number;

    destineringsalternativ: DestineringsalternativViewModel[];

    handelssortimentsgruppSekvensnummer: number;

    constructor(init: (instance: ArbetsorderHandelssortimentViewModel) => void) {
        init(this);
    }
}

export class DestineringsalternativStatus {
    static readonly Complete = "complete";
    static readonly Empty = "empty";
    static readonly Beraknar = "beraknar";
}

export class Destineringsursprung {
    static readonly Okand = 0;
    static readonly Kundorderrad = 1;
    static readonly RelateratHandelssortiment = 2;
    static readonly AlternativtHandelssortiment = 4;
    static readonly Extrarad = 8;
    static readonly AlternativMottagningsplats = 16;
    static readonly ForadlatHandelssortiment = 32;
    static readonly ManuellRad = 64;

    static readonly Destinerbart = Destineringsursprung.Kundorderrad | Destineringsursprung.RelateratHandelssortiment |
        Destineringsursprung.AlternativtHandelssortiment | Destineringsursprung.ManuellRad;
}
export class DestineringsalternativArbetsorderOption {
    arbetsorderId: number;
    headerRow: string;
    mottagningsplatsNamn: string;
    mottagningsplatsnummer: string;
    mottagningsplatsId: number;
    handelssortimentNamn: string;
    handelssortimentId: number;
    destineringsursprung: number;
    egenskapskodX: boolean;
    overstyrdAvlastningsplats: string;
    foradlatHandelssortimentId: number;
    inmatningshandelssortimentId: number;

    constructor(init: (instance: DestineringsalternativArbetsorderOption) => void) {
        init(this);
    }

    get isAlternativt(): boolean {
        return (this.destineringsursprung & Destineringsursprung.AlternativtHandelssortiment) > 0;
    }

}
export class DestineringsalternativManuella {
    mottagningsplatsNamn: string;
    mottagningsplatsnummer: string;
    mottagningsplatsId: number;
    handelssortimentNamn: string;
    handelssortimentId: number;
    headerRow: string;
    laggtill: boolean;
    tidigareVald: boolean;
    destineringsursprung: number;
    egenskapskodX: boolean;
    overstyrdAvlastningsplats: string;
    foradlatHandelssortimentId: number;
    inmatningshandelssortimentId: number;

    constructor(init: (instance: DestineringsalternativManuella) => void) {
        init(this);
    }

    get isAlternativt(): boolean {
        return (this.destineringsursprung & Destineringsursprung.AlternativtHandelssortiment) > 0;
    }

    get isAdd(): boolean {
        return this.laggtill && !this.tidigareVald;
    }

    get isRemoved(): boolean {
        return !this.laggtill && this.tidigareVald;
    }
}

export class DestineringsalternativViewModel {
    id: number;
    aktiv: boolean;
    arbetsorderHandelssortiment: ArbetsorderHandelssortimentViewModel;
    foradlatHandelssortimentId?: number;
    destineringUid: string;
    mottagningsplatsId: number;
    mottagningsplatsNamn: string;
    mottagningsplatsnummer: string;
    andel: number;
    destineringsursprung: number;
    kvvTransportavstand: number;
    extraKm: number;
    tillaggsavstandStorstaAvlagg?: number;
    justeratTransportavstand: number;
    isModified: boolean;

    status = DestineringsalternativStatus.Complete;

    alertValidationMessage: string;

    constructor(init: (instance: DestineringsalternativViewModel) => void) {
        init(this);
    }

    get transportavstand(): number {
        return this.kvvTransportavstand + this.extraKm + this.tillaggsavstandStorstaAvlagg;
    }

    get isKundorderrad(): boolean {
        return (this.destineringsursprung & Destineringsursprung.Kundorderrad) > 0;
    }

    get isRelaterat(): boolean {
        return (this.destineringsursprung & Destineringsursprung.RelateratHandelssortiment) > 0;
    }

    get isAlternativt(): boolean {
        return (this.destineringsursprung & Destineringsursprung.AlternativtHandelssortiment) > 0;
    }

    get isExtraMottagningsplats(): boolean {
        return (this.destineringsursprung & Destineringsursprung.Extrarad) > 0;
    }

    get isAlternativMottagningsplats(): boolean {
        return (this.destineringsursprung & Destineringsursprung.AlternativMottagningsplats) > 0;
    }

    get isForadlatHandelssortiment(): boolean {
        return (this.destineringsursprung & Destineringsursprung.ForadlatHandelssortiment) > 0;
    }

    get isManuellRad(): boolean {
        return (this.destineringsursprung & Destineringsursprung.ManuellRad) > 0;
    }

    get isOgiltig(): boolean {
        return this.destineringsursprung === 0;
    }

    get destinerbart(): boolean {
        if (!this.aktiv) {
            return false;
        }

        if (this.andel) {
            return true;
        }
        return (this.destineringsursprung & Destineringsursprung.Destinerbart) > 0 && (this.destineringsursprung & Destineringsursprung.AlternativMottagningsplats) === 0;
    }

    get ruleName(): string {
        return `${this.arbetsorderHandelssortiment.id}_${this.id}`;
    }

    get formattedDestineringsursprung(): string {
        const res = [];

        if (this.isKundorderrad) {
            res.push("Kundorderrad");
        }
        if (this.isAlternativt) {
            res.push("Alternativt handelssortiment");
        }
        if (this.isRelaterat) {
            res.push("Relaterat handelssortiment");
        }
        if (this.isExtraMottagningsplats) {
            res.push("Extra mottagningsplats");
        }
        if (this.isAlternativMottagningsplats) {
            res.push("Alternativ mottagningsplats");
        }
        if (this.isForadlatHandelssortiment) {
            res.push("Förädlat handelssortiment");
        }
        if (this.isOgiltig) {
            res.push("Okänd");
        }
        return res.join(", ");
    }
}

export class ArbestorderDestineringsalternativViewModel {
    readonly arbetsorderHandelssortiment: ArbetsorderHandelssortimentViewModel[];

    minTransportdatumBeraknatFrom: Date;
    maxTransportdatumBeraknatTom: Date;

    constructor(ahs: ArbetsorderHandelssortimentDTO[], destineringar: DestineringsalternativDTO[]) {

        const arbetsorderHandelssortiment = this.mapArbetsorderHandelssortiment(ahs, destineringar, DestineringsalternativStatus.Empty);
        this.arbetsorderHandelssortiment = arbetsorderHandelssortiment;

        this.setAggregatedTransportdatum();
    }

    addArbetsorderHandelssortiment(ahsDtos: ArbetsorderHandelssortimentDTO[]) {
        const arbetsorderHandelssortimentArr = this.mapArbetsorderHandelssortiment(ahsDtos, [], DestineringsalternativStatus.Beraknar);

        arbetsorderHandelssortimentArr.forEach(ahs => {
            const targetAhs = this.arbetsorderHandelssortiment.find(x => x.id === ahs.id);
            if (targetAhs) {
                return;
            }

            const insertionIndex = this.arbetsorderHandelssortiment.findIndex(existing => existing.handelssortimentsgruppSekvensnummer > ahs.handelssortimentsgruppSekvensnummer);

            // Peta in rad på korrekt ställe i listan
            if (insertionIndex === -1) {
                this.arbetsorderHandelssortiment.push(ahs);
            } else {
                this.arbetsorderHandelssortiment.splice(insertionIndex, 0, ahs);
            }
        });

        this.setAggregatedTransportdatum();
    }

    mergeDestineringsalternativ(targetAhsIsList: number[], destDtos: DestineringsalternativDTO[]) {
        targetAhsIsList.forEach(ahsId => {
            const ahsvm = this.arbetsorderHandelssortiment.find(ahs => ahs.id === ahsId);
            if (!ahsvm) {
                return;
            }

            const dtos = destDtos.filter(x => x.handelssortimentId === ahsvm.handelssortimentId);

            const hasPlaceholderDestineringsalternativ = ahsvm.destineringsalternativ.some(x => x.status !== DestineringsalternativStatus.Complete);
            if (hasPlaceholderDestineringsalternativ) {
                ahsvm.destineringsalternativ = ahsvm.destineringsalternativ.filter(x => x.status === DestineringsalternativStatus.Complete);
            }

            const removed = ahsvm.destineringsalternativ.filter(x => !dtos.some(e => e.id === x.id));
            if (removed.length) {
                ahsvm.destineringsalternativ = ahsvm.destineringsalternativ.filter(x => !removed.some(e => e.id === x.id));
            }

            // merge matched
            ahsvm.destineringsalternativ.forEach(x => {
                const dto = dtos.find(d => d.id === x.id);
                if (!dto) {
                    return;
                }
                x.destineringsursprung = dto.destineringsursprung;
            });

            const added = dtos.filter(x => !ahsvm.destineringsalternativ.some(e => e.id === x.id));
            this.writeDestineringsalternativ(ahsvm, added, DestineringsalternativStatus.Empty);
        });
    }

    updateDestineringsalternativ(destDtos: DestineringsalternativDTO[]) {
        destDtos.forEach(destDto => {
            const ahsvm = this.arbetsorderHandelssortiment.find(ahs => ahs.handelssortimentId === destDto.handelssortimentId);
            if (!ahsvm) {
                return;
            }
            const dest = ahsvm.destineringsalternativ.find(d => d.id === destDto.id);
            if (!dest) {
                return;
            }
            dest.status = DestineringsalternativStatus.Complete;
            dest.destineringsursprung = destDto.destineringsursprung;
            dest.kvvTransportavstand = destDto.transportavstand.krontVagvalKm;
            dest.isModified = destDto.transportavstand.isModified ||
                !ObjectUtils.isNullOrUndefined(destDto.tillaggsavstandStorstaAvlagg) ||
                !ObjectUtils.isNullOrUndefined(destDto.transportavstand?.extraKm);
            dest.extraKm = destDto.transportavstand.extraKm;
            dest.tillaggsavstandStorstaAvlagg = destDto.tillaggsavstandStorstaAvlagg;
        });
    }

    removeArbetsorderHandelssortiment(id: number): void {
        const idx = this.arbetsorderHandelssortiment.findIndex(x => x.id === id);
        if (idx < 0) {
            return;
        }
        this.arbetsorderHandelssortiment.splice(idx, 1);
    }

    setAlert(destineringId: number, message: string): void {
        const destinering = flatMap(this.arbetsorderHandelssortiment, ahs => ahs.destineringsalternativ).find(x => x.id === destineringId);
        if (!destinering) {
            return;
        }

        destinering.alertValidationMessage = message;
    }

    private setAggregatedTransportdatum(): void {
        this.minTransportdatumBeraknatFrom = minBy(this.arbetsorderHandelssortiment, x => x.transportdatumBeraknatFrom)?.transportdatumBeraknatFrom;
        this.maxTransportdatumBeraknatTom = maxBy(this.arbetsorderHandelssortiment, x => x.transportdatumBeraknatTom)?.transportdatumBeraknatTom;

    }

    private mapArbetsorderHandelssortiment(
        ahsDtos: ArbetsorderHandelssortimentDTO[],
        destDtos: DestineringsalternativDTO[],
        defaultAlternativStatus: string): ArbetsorderHandelssortimentViewModel[] {
        return ahsDtos.map(x => new ArbetsorderHandelssortimentViewModel(ahsvm => {
            ahsvm.id = x.id;
            ahsvm.handelssortimentId = x.handelssortimentId;
            ahsvm.handelssortimentNamn = x.handelssortimentNamn;
            ahsvm.handelssortimentGuid = x.handelssortimentGuid;
            ahsvm.transportdatumBeraknatFrom = x.transportdatumBeraknatFrom;
            ahsvm.transportdatumBeraknatTom = x.transportdatumBeraknatTom;
            ahsvm.beraknaNarmasteIndustri = x.beraknaNarmasteIndustri;
            ahsvm.avstandNarmasteIndustri = x.avstandNarmasteIndustri;
            ahsvm.avstandNarmasteIndustriJusterat = x.avstandNarmasteIndustriJusterat;
            ahsvm.handelssortimentsgruppSekvensnummer = x.handelssortimentsgruppSekvensnummer;

            const targetDestDtos = destDtos.filter(d => d.handelssortimentId === x.handelssortimentId);
            this.writeDestineringsalternativ(ahsvm, targetDestDtos, defaultAlternativStatus);
        }));
    }

    private writeDestineringsalternativ(
        ahsvm: ArbetsorderHandelssortimentViewModel,
        destDtos: DestineringsalternativDTO[],
        defaultAlternativStatus: string): DestineringsalternativViewModel[] {

        const mapped = destDtos.map(d => new DestineringsalternativViewModel(dvm => {
            dvm.id = d.id;
            dvm.aktiv = d.aktiv;
            dvm.arbetsorderHandelssortiment = ahsvm;
            dvm.mottagningsplatsId = d.mottagningsplatsId;
            dvm.mottagningsplatsNamn = d.mottagningsplatsNamn;
            dvm.mottagningsplatsnummer = d.mottagningsplatsnummer;
            dvm.andel = d.andel;
            dvm.alertValidationMessage = d.alertValidationMessage;
            dvm.kvvTransportavstand = d.transportavstand?.krontVagvalKm;
            dvm.extraKm = d.transportavstand?.extraKm;
            dvm.tillaggsavstandStorstaAvlagg = d.tillaggsavstandStorstaAvlagg;
            dvm.destineringsursprung = d.destineringsursprung;
            dvm.isModified = d.transportavstand?.isModified ||
                !ObjectUtils.isNullOrUndefined(d.tillaggsavstandStorstaAvlagg) ||
                !ObjectUtils.isNullOrUndefined(d.transportavstand?.extraKm);
            dvm.foradlatHandelssortimentId = d.foradlatHandelssortimentId;
            dvm.destineringUid = d.destineringUid;
        }));

        if (!ahsvm.destineringsalternativ) {
            ahsvm.destineringsalternativ = [];
        }

        ahsvm.destineringsalternativ.push(...mapped);

        this.checkAddPlaceholder(ahsvm, defaultAlternativStatus);

        return ahsvm.destineringsalternativ;
    }

    private checkAddPlaceholder(ahsvm: ArbetsorderHandelssortimentViewModel, defaultAlternativStatus: string) {
        if (ahsvm.destineringsalternativ.length !== 0) {
            return;
        }

        const placeholder = new DestineringsalternativViewModel(dvm => {
            dvm.arbetsorderHandelssortiment = ahsvm;
            dvm.status = defaultAlternativStatus;
        });

        ahsvm.destineringsalternativ.push(placeholder);
    }
}
